export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geschäft auswählen"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ohne Titel"])}
}